export const categories = [
  {
    name: "Cars",
    imageSrc: "/assets/images/categories/cars.png",
  },
  {
    name: "Laptops",
    imageSrc: "/assets/images/categories/laptops.png",
  },
  {
    name: "Cellphones",
    imageSrc: "/assets/images/categories/cellphones.png",
  },
  {
    name: "Electronics",
    imageSrc: "/assets/images/categories/electronics.png",
  },
  {
    name: "Computers and Networking",
    imageSrc: "/assets/images/categories/computer_and_networking.png",
  },
  {
    name: "Home and Living",
    imageSrc: "/assets/images/categories/home_and_living.png",
  },
  {
    name: "Baby and Kids",
    imageSrc: "/assets/images/categories/baby_and_kids.png",
  },
  {
    name: "Property",
    imageSrc: "/assets/images/categories/property.png",
  },
  {
    name: "Motorcycles and Scooters",
    imageSrc: "/assets/images/categories/motorcycles_and_scooters.png",
  },
  {
    name: "Sports and Leisure",
    imageSrc: "/assets/images/categories/sports_and_leisure.png",
  },
  {
    name: "Fashion and Beauty",
    imageSrc: "/assets/images/categories/fashion_and_beauty.png",
  },
];
